export const TermType = {
	DAYS: 'DAYS',
	MONTHS: 'MONTHS',
	YEARS: 'YEARS',

	values: () => {
		return ['DAYS', 'MONTHS', 'YEARS'];
	},
};
